import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { TransactionHistoryPageComponent } from './transaction-history.page';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: TransactionHistoryPageComponent,
    path: ''
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class TransactionHistoryPageRoutingModule {}
